module.exports = __webpack_public_path__ + "img/8select-1.eade08c0.jpg";